import styled from '@emotion/styled';
import { Button, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { YELLOW } from '../../../shared/colors';

const Container = styled.div`
  th {
    background-color: ${YELLOW} !important;
    color: white !important;
    font-weight: bold;
  }

  .style-row {
    font-family: Poppins-L;
    color: black;

    &:hover > td {
      background-color: #eee !important;
      cursor: pointer;
    }
  }

  .even {
    background-color: #eee;
  }

  .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 2px 5px;
  }

  > .picker {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    margin-bottom: 15px;
  }

  @media (max-width: 767px) {
    > .picker {
      align-items: stretch;
      flex-direction: column;
    }
  }
`;

export const Bourse = () => {
  const [bourses, setBourses] = useState<{
    nbre: string,
    nom: string,
    pays: string,
    number: string,
    date: string,
    adresse: string
  }[]>([]);
  const [filterbourses, setFilterbourses] = useState<{
    nbre: string,
    nom: string,
    pays: string,
    number: string,
    date: string,
    adresse: string
  }[]>([]);
  const [selectData, setSelectData] = useState('');

  useEffect(() => {
    setBourses(BOURSES);
    setFilterbourses(BOURSES);
  }, []);

  const filter = (value:string) => {
    if (value) {
      setFilterbourses(
        bourses.filter((ac) => {
          console.log(value, bourses, ac.nom.includes(value));
          if (ac.nom.indexOf(value) > -1 || ac.pays.indexOf(value) > -1 ) {
            return true;
          }
          return false;
        }),
      );
    } else {
      setFilterbourses(BOURSES)
    }
  };

  const search = ()=>filter(selectData)

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectData(value);
    filter(value)
  };
  const COLUMNS = [
    {
      title: '#',
      dataIndex: 'nbre',
      width: 50,
    },
    {
      title: 'Etablissement',
      dataIndex: 'nom',
      width: 400,
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      width: 100,
    },
    {
      title: 'N° Agrément',
      dataIndex: 'number',
      width: 200,
    },
    {
      title: "Date d'agrément",
      dataIndex: 'date',
      width: 150,
    },
    {
      title: 'Adresse',
      dataIndex: 'adresse',
      width: 500,
    },
  ];

  return (
    <Container>
      <div className='picker'>
        <Input 
          size='middle'
          placeholder='Rechercher un pays ou une société'
          type='text'
          onChange={handleInput}
        />
        <Button className='butt' onClick={search}>
          Valider
        </Button>
      </div>

      <div></div>
      <Table
        columns={COLUMNS}
        dataSource={filterbourses}
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'style-row even' : 'style-row'
        }
        scroll={{ x: 1050 }}
        size='small'
      // style={{ zoom: 1 }}
      // pagination={false}
      />
    </Container>
  );
};

const BOURSES = [
  {
    nbre: '1',
    nom: 'BGFI BOURSE',
    pays: 'Gabon',
    number: 'MFAC-SB-002/2006',
    date: '20/12/2006',
    adresse:
      '1295, Boulevard de l&rsquo;indépendance &#8211; BP 2253 Libreville',
  },
  {
    nbre: '2',
    nom: 'EDC INVESTMENT CORPORATION',
    pays: 'Cameroun',
    number: 'MFAC-SB-003/2007',
    date: '13/12/2007',
    adresse:
      'Immeuble ACTIVA, 2ème étage, rue Prince de Galles, AKWA &#8211; BP : 15385 Douala',
  },
  {
    nbre: '3',
    nom: 'FINANCIA CAPITAL',
    pays: 'Cameroun',
    number: 'MFAC-SB-004/2011',
    date: '17/11/2011',
    adresse: '125, Rue de La Perousse, Bonanjo &#8211; BP : 4593 Douala',
  },
  {
    nbre: '4',
    nom: 'LCB CAPITAL',
    pays: 'Congo',
    number: 'MFAC-SB-01/2015',
    date: '26/05/2015',
    adresse: '3, Avenue Amilcar Cabral, BP : 2889 Brazzavile',
  },
  {
    nbre: '5',
    nom: 'ATTIJARI SECURITIES CENTRAL AFRICA  (ASCA)',
    pays: 'Cameroun',
    number: 'MFAC-SB-01/2016',
    date: '01/03/2016',
    adresse:
      'Rue njo njo, Carrefour Soppo Priso, immeuble du phare, 3e étage, Bonapriso &#8211; BP : 255 Douala',
  },
  {
    nbre: '6',
    nom: 'CBT BOURSE',
    pays: 'Tchad',
    number: 'MFAC-SB-02/2016',
    date: '14/06/2016',
    adresse: 'Avenue Maldom Bada Abbas &#8211; BP : 19 N&rsquo;Djamena',
  },
  {
    nbre: '7',
    nom: 'SOCIETE SAHELIENNE D&rsquo;INTERMEDIATION FINANCIERE DE L&rsquo;AFRIQUE CENTRALE (SAIFAC)',
    pays: 'Cameroun',
    number: '084/10/CMF/18',
    date: '30/10/2018',
    adresse: '1063, Place de l&rsquo;indépendance &#8211; BP : 11834 Yaoundé',
  },
  {
    nbre: '8',
    nom: 'GLOBAL TRADE INTERNATIONAL INVESTMENT (GTI)',
    pays: 'Cameroun',
    number: '086/10/CMF/18',
    date: '30/10/2018',
    adresse:
      '234, Avenue de l&rsquo;indépendance, Carrefour Hôtel de l&rsquo;Air, Bonapriso &#8211; BP : 1925 Douala',
  },
  {
    nbre: '9',
    nom: 'SG CAPITAL SECURITIES &#8211; CENTRAL AFRICA',
    pays: 'Cameroun',
    number: '091/10/CMF/18',
    date: '30/10/2018',
    adresse: ' Rue du Pasteur Lotin Same, Akwa',
  },
  {
    nbre: '10',
    nom: 'AFRILAND BOURSE &amp; INVESTISSEMENT S.A',
    pays: 'Cameroun',
    number: 'MFAC-SDB-01/2019',
    date: '30/12/2019',
    adresse: 'Carrefour Biyem-assi, BP : 14583 Yaoundé',
  },
  {
    nbre: '11',
    nom: 'UPLINE SECURITIES CENTRAL AFRICA  (USCA)',
    pays: 'Cameroun',
    number: 'MFAC-SDB-02/2019',
    date: '30/12/2019',
    adresse: '78, Rue Joss, Bonanjo, BP 4042 Douala',
  },
  {
    nbre: '12',
    nom: 'AFRICA BRIGHT SECURITIES S.A (ABS)',
    pays: 'Cameroun',
    number: 'MFAC-SDB-02/2020',
    date: '15/07/2020',
    adresse:
      'Rue du Pasteur Lotin SAME, NBC-Rue Laborex, quartier Akwa, à Douala, (République du Cameroun), BP: 512',
  },
  {
    nbre: '13',
    nom: 'CBC BOURSE',
    pays: 'Cameroun',
    number: 'MFAC-SB-01/2020',
    date: '04/03/2020',
    adresse: 'Bonanjo &#8211; Douala / BP: 4004',
  },
  {
    nbre: '14',
    nom: 'AFG CAPITAL CENTRAL AFRICA S.A &#8211; (ACCA)',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-03/2020',
    date: '25/09/2020',
    adresse: 'Immeuble du phare Bonapriso, 4 eme étage, BP. 255 Douala',
  },
  {
    nbre: '15',
    nom: 'EMRALD SECURITIES SERVICES BOURSE S.A (ESS Bourse)',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-04/2020',
    date: '08/12/2020',
    adresse:
      'Immeuble Victoria 3ème étage- BP: 5540 Bonanjo (Douala &#8211; Cameroun)',
  },
  {
    nbre: '16',
    nom: 'L&rsquo;ARCHER CAPITAL SECURITIES S.A (ACS)',
    pays: 'Congo',
    number: 'COSUMAF-SDB-01/2021',
    date: '11/03/2020',
    adresse:
      '70 rue de la Musique Tambourinée, Immeuble CORAY-RESIDENCE, 2ème étage, Brazzaville -Congo',
  },
  {
    nbre: '17',
    nom: 'HORUS INVESTMENT CAPITAL S.A',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-02/2021',
    date: '17/06/2021',
    adresse:
      ' Immeuble SOTICAM, face Total Bonjour, 1er étage, BP 13207,  Bonapriso-Douala (République du Cameroun)',
  },
  {
    nbre: '18',
    nom: 'BEKO CAPITAL ADVISORY S.A',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-03/2021',
    date: '28/07/2021',
    adresse:
      'Avenue Douala manga Bell, Immeuble Diamaré, Niveau 2, Akwa, Douala-Cameroun',
  },
  {
    nbre: '19',
    nom: 'BANGE SOCIEDAD DE VALORES S.A',
    pays: 'Guinée-Equatoriale',
    number: 'COSUMAF-SDB-04/2021',
    date: '28/07/2021',
    adresse:
      'Avenida  de las Naciones Unidas, N° 28 APDO 430, Malabo-Guinea Ecuatorial',
  },
  {
    nbre: '20',
    nom: 'ELITE CAPITAL SECURITIES CENTRAL AFRICA S.S (EXCA S.A)',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-05/2021',
    date: '16/12/2021',
    adresse:
      '4ème  étage Immeuble FENA- Nouvelle route Basto, à côté de Zenithe Insurance, BP : 35 303 Yaoundé &#8211; République du Cameroun. Tél: 676 61 41 58',
  },
  {
    nbre: '21',
    nom: 'PREMIUM CAPITAL SECURITIES S.A',
    pays: 'Congo',
    number: 'COSUMAF-SDB-06/2021',
    date: '16/12/2021',
    adresse:
      '800, Rue Moukoukoulou Plateau des 15 ans Moungali, Brazzaville – République du Congo',
  },
  {
    nbre: '22',
    nom: 'CCA BOURSE S.A',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-01/2022',
    date: '29/09/2022',
    adresse: 'Immeuble CCA BANK AKWA-Douala- Cameroun',
  },
  {
    nbre: '23',
    nom: 'DIGICAPITAL BOURSE S.A.',
    pays: 'Cameroun',
    number: 'COSUMAF-SDB-02/2022',
    date: '20/12/2022',
    adresse:
      'Yaoundé, Carrefour Bastos (Ambassade Suisse)/ Succursale: Douala-Bonanjo, Rue Joss (face maison de la radio)',
  },
];
